import http from "./httpservices";
import GetCookieByName from "../hooks/GetCookie";

function getAuthToken() {
  try {
    const raw = GetCookieByName("auth");
    if (typeof raw !== "string") return undefined;
    return JSON.parse(raw)["token"];
  } catch {
    return undefined;
  }
}

export async function getLimitedInfluencers() {
  const { data } = await http.get("influencer/showinfluencerlimit", {
    headers: { "x-auth-token": getAuthToken() },
  });
  return data;
}

export async function getInfluencersCount() {
  const { data } = await http.get(`influencer/influencerscount`, {
    headers: { "x-auth-token": getAuthToken() },
  });
  return data;
}

export async function findByUserName(search) {
  const { data } = await http.post("influencer/findbyusername", {
    username: search,
  }, {
    headers: { "x-auth-token": getAuthToken() },
  });
  return data;
}

export async function removeCreator(id) {
  const { data } = await http.delete(
    `/influencer/${id}`,
    { headers: { "x-auth-token": getAuthToken() } }
  );

  return data;
}

const influencerservice = {
  getLimitedInfluencers,
  getInfluencersCount,
  findByUserName,
  removeCreator
};

export default influencerservice;